'use client';

export const CloseIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15 5L5 15M5 5L15 15"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CalendarDotsIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13 2.5H3C2.72386 2.5 2.5 2.72386 2.5 3V13C2.5 13.2761 2.72386 13.5 3 13.5H13C13.2761 13.5 13.5 13.2761 13.5 13V3C13.5 2.72386 13.2761 2.5 13 2.5Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M11 1.5V3.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M5 1.5V3.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M2.5 5.5H13.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="5" cy="8" r="0.75" fill="currentColor" />
    <circle cx="8" cy="8" r="0.75" fill="currentColor" />
    <circle cx="11" cy="8" r="0.75" fill="currentColor" />
    <circle cx="5" cy="11" r="0.75" fill="currentColor" />
    <circle cx="8" cy="11" r="0.75" fill="currentColor" />
  </svg>
);

export const MapPinIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8 8.5C9.10457 8.5 10 7.60457 10 6.5C10 5.39543 9.10457 4.5 8 4.5C6.89543 4.5 6 5.39543 6 6.5C6 7.60457 6.89543 8.5 8 8.5Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13 6.5C13 11 8 14.5 8 14.5C8 14.5 3 11 3 6.5C3 5.17392 3.52678 3.90215 4.46447 2.96447C5.40215 2.02678 6.67392 1.5 8 1.5C9.32608 1.5 10.5979 2.02678 11.5355 2.96447C12.4732 3.90215 13 5.17392 13 6.5Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TelegramIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.5 2L7.5 9M14.5 2L10 14L7.5 9M14.5 2L1.5 6.5L7.5 9"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CalendarIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13 2.5H3C2.72386 2.5 2.5 2.72386 2.5 3V13C2.5 13.2761 2.72386 13.5 3 13.5H13C13.2761 13.5 13.5 13.2761 13.5 13V3C13.5 2.72386 13.2761 2.5 13 2.5Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M11 1.5V3.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M5 1.5V3.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M2.5 5.5H13.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const UserIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8 10C10.2091 10 12 8.20914 12 6C12 3.79086 10.2091 2 8 2C5.79086 2 4 3.79086 4 6C4 8.20914 5.79086 10 8 10Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 14C2 12.4087 2.63214 10.8826 3.75736 9.75736C4.88258 8.63214 6.4087 8 8 8C9.5913 8 11.1174 8.63214 12.2426 9.75736C13.3679 10.8826 14 12.4087 14 14"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CalendarPlusIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13 2.5H3C2.72386 2.5 2.5 2.72386 2.5 3V13C2.5 13.2761 2.72386 13.5 3 13.5H13C13.2761 13.5 13.5 13.2761 13.5 13V3C13.5 2.72386 13.2761 2.5 13 2.5Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M11 1.5V3.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M5 1.5V3.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M2.5 5.5H13.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8 8V12" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M6 10H10" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const CirclesThreeIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="8" cy="4" r="2.5" stroke="currentColor" />
    <circle cx="4" cy="11" r="2.5" stroke="currentColor" />
    <circle cx="12" cy="11" r="2.5" stroke="currentColor" />
  </svg>
);

export const ArrowRightIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.156 3.5V9.1875C11.156 9.36155 11.0868 9.52847 10.9638 9.65154C10.8407 9.77461 10.6738 9.84375 10.4997 9.84375C10.3257 9.84375 10.1588 9.77461 10.0357 9.65154C9.91262 9.52847 9.84348 9.36155 9.84348 9.1875V5.08594L3.96403 10.9643C3.84074 11.0876 3.67354 11.1568 3.49919 11.1568C3.32484 11.1568 3.15763 11.0876 3.03434 10.9643C2.91106 10.841 2.8418 10.6738 2.8418 10.4995C2.8418 10.3251 2.91106 10.1579 3.03434 10.0346L8.91379 4.15625H4.81223C4.63818 4.15625 4.47126 4.08711 4.34819 3.96404C4.22512 3.84097 4.15598 3.67405 4.15598 3.5C4.15598 3.32595 4.22512 3.15903 4.34819 3.03596C4.47126 2.91289 4.63818 2.84375 4.81223 2.84375H10.4997C10.6738 2.84375 10.8407 2.91289 10.9638 3.03596C11.0868 3.15903 11.156 3.32595 11.156 3.5Z"
      fill="#1B4DFF"
    />
  </svg>
);

export const ChevronDownIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.5 5.5L8 10L3.5 5.5" stroke="#8897AE" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const WebIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="8" cy="8" r="6.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M1.5 8H14.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M8 1.5C9.65685 3.15685 10.6046 5.52724 10.6046 8C10.6046 10.4728 9.65685 12.8431 8 14.5C6.34315 12.8431 5.39543 10.4728 5.39543 8C5.39543 5.52724 6.34315 3.15685 8 1.5Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TwitterIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.6 1.5H14.9L9.9 7.3L15.8 14.5H11.2L7.5 9.7L3.3 14.5H1L6.3 8.3L0.7 1.5H5.4L8.8 5.9L12.6 1.5ZM11.8 13.2H13.1L4.7 2.8H3.3L11.8 13.2Z"
      fill="currentColor"
    />
  </svg>
);

export const SlidersHorizontalIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.4375 6.25H5.625" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8.75 6.25H16.5625" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M3.4375 13.75H11.25"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.375 13.75H16.5625"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.1875 8.4375C8.39562 8.4375 9.375 7.45812 9.375 6.25C9.375 5.04188 8.39562 4.0625 7.1875 4.0625C5.97938 4.0625 5 5.04188 5 6.25C5 7.45812 5.97938 8.4375 7.1875 8.4375Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.8125 15.9375C14.0206 15.9375 15 14.9581 15 13.75C15 12.5419 14.0206 11.5625 12.8125 11.5625C11.6044 11.5625 10.625 12.5419 10.625 13.75C10.625 14.9581 11.6044 15.9375 12.8125 15.9375Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CaretUpIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.25 11.25L9 6L3.75 11.25"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CaretDownIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.75 6.75L9 12L14.25 6.75"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CheckIcon = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 3L4.5 8.5L2 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const SearchIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.0625 15.625C12.6869 15.625 15.625 12.6869 15.625 9.0625C15.625 5.43813 12.6869 2.5 9.0625 2.5C5.43813 2.5 2.5 5.43813 2.5 9.0625C2.5 12.6869 5.43813 15.625 9.0625 15.625Z"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.7031 13.7031L17.5 17.5"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const XCircleIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.5 7.5L7.5 12.5"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.5 12.5L7.5 7.5"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DiamondsFourIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10 2.5L12.5 5L10 7.5L7.5 5L10 2.5Z"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 7.5L17.5 10L15 12.5L12.5 10L15 7.5Z"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 12.5L12.5 15L10 17.5L7.5 15L10 12.5Z"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 7.5L7.5 10L5 12.5L2.5 10L5 7.5Z"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CaretDownSmallIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.5 6L8 10.5L3.5 6"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const AddressBookIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.625 2.5H5C4.66848 2.5 4.35054 2.6317 4.11612 2.86612C3.8817 3.10054 3.75 3.41848 3.75 3.75V16.25C3.75 16.5815 3.8817 16.8995 4.11612 17.1339C4.35054 17.3683 4.66848 17.5 5 17.5H15.625C15.7908 17.5 15.9497 17.4342 16.0669 17.3169C16.1842 17.1997 16.25 17.0408 16.25 16.875V3.125C16.25 2.95924 16.1842 2.80027 16.0669 2.68306C15.9497 2.56585 15.7908 2.5 15.625 2.5Z"
      stroke="#1B4DFF"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 10.625C11.0355 10.625 11.875 9.78553 11.875 8.75C11.875 7.71447 11.0355 6.875 10 6.875C8.96447 6.875 8.125 7.71447 8.125 8.75C8.125 9.78553 8.96447 10.625 10 10.625Z"
      stroke="#1B4DFF"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.1875 13.125C7.35628 12.5279 7.72164 12.0052 8.22489 11.6413C8.72814 11.2774 9.34009 11.0927 9.96484 11.0927C10.5896 11.0927 11.2016 11.2774 11.7048 11.6413C12.2081 12.0052 12.5734 12.5279 12.7422 13.125"
      stroke="#1B4DFF"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M1.5625 6.25H3.75" stroke="#1B4DFF" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M1.5625 10H3.75" stroke="#1B4DFF" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M1.5625 13.75H3.75" stroke="#1B4DFF" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const MastodonIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
    <path d="M433 179.1c0-97.2-63.7-125.7-63.7-125.7-62.5-28.7-228.6-28.4-290.5 0 0 0-63.7 28.5-63.7 125.7 0 115.7-6.6 259.4 105.6 289.1 40.5 10.7 75.3 13 103.3 11.4 50.8-2.8 79.3-18.1 79.3-18.1l-1.7-36.9s-36.3 11.4-77.1 10.1c-40.4-1.4-83-4.4-89.6-54-.6-4.6-.9-9.3-.9-13.9 85.6 20.9 158.7 9.1 178.7 6.7 56.1-6.7 105-41.3 111.2-72.9 9.8-49.8 9-121.5 9-121.5zM357.9 304.3l-46.6 0 0-114.2c0-49.7-64-51.6-64 6.9l0 62.5-46.3 0 0-62.5c0-58.5-64-56.6-64-6.9l0 114.2-46.7 0c0-122.1-5.2-147.9 18.4-175 25.9-28.9 79.8-30.8 103.8 6.1l11.6 19.5 11.6-19.5c24.1-37.1 78.1-34.8 103.8-6.1 23.7 27.3 18.4 53 18.4 175l0 0z" />
  </svg>
);

export const BlueskyIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
    <path d="M407.8 294.7c-3.3-.4-6.7-.8-10-1.3 3.4 .4 6.7 .9 10 1.3zM288 227.1C261.9 176.4 190.9 81.9 124.9 35.3 61.6-9.4 37.5-1.7 21.6 5.5 3.3 13.8 0 41.9 0 58.4S9.1 194 15 213.9c19.5 65.7 89.1 87.9 153.2 80.7 3.3-.5 6.6-.9 10-1.4-3.3 .5-6.6 1-10 1.4-93.9 14-177.3 48.2-67.9 169.9 120.3 124.6 164.8-26.7 187.7-103.4 22.9 76.7 49.2 222.5 185.6 103.4 102.4-103.4 28.1-156-65.8-169.9-3.3-.4-6.7-.8-10-1.3 3.4 .4 6.7 .9 10 1.3 64.1 7.1 133.6-15.1 153.2-80.7 5.9-19.9 15-138.9 15-155.5s-3.3-44.7-21.6-52.9c-15.8-7.1-40-14.9-103.2 29.8-66.1 46.6-137.1 141.1-163.2 191.8z" />
  </svg>
);

export const OtherResourceIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11 4.75C11 4.15666 10.8241 3.57664 10.4944 3.08329C10.1648 2.58994 9.69623 2.20543 9.14805 1.97836C8.59987 1.7513 7.99667 1.69189 7.41473 1.80765C6.83279 1.9234 6.29824 2.20912 5.87868 2.62868C5.45912 3.04824 5.1734 3.58279 5.05765 4.16473C4.94189 4.74667 5.0013 5.34987 5.22836 5.89805C5.45543 6.44623 5.83994 6.91477 6.33329 7.24441C6.82664 7.57405 7.40666 7.75 8 7.75C8.7954 7.74917 9.55798 7.43284 10.1204 6.87041C10.6828 6.30798 10.9992 5.5454 11 4.75ZM8 6.25C7.70333 6.25 7.41332 6.16203 7.16665 5.99721C6.91997 5.83238 6.72771 5.59812 6.61418 5.32403C6.50065 5.04994 6.47095 4.74834 6.52882 4.45737C6.5867 4.16639 6.72956 3.89912 6.93934 3.68934C7.14912 3.47956 7.41639 3.3367 7.70737 3.27882C7.99834 3.22095 8.29994 3.25065 8.57403 3.36418C8.84812 3.47771 9.08238 3.66997 9.24721 3.91665C9.41203 4.16332 9.5 4.45333 9.5 4.75C9.5 5.14783 9.34197 5.52936 9.06066 5.81066C8.77936 6.09197 8.39783 6.25 8 6.25ZM11.75 7.75C11.1567 7.75 10.5766 7.92595 10.0833 8.25559C9.58994 8.58524 9.20543 9.05377 8.97836 9.60195C8.7513 10.1501 8.69189 10.7533 8.80765 11.3353C8.9234 11.9172 9.20912 12.4518 9.62868 12.8713C10.0482 13.2909 10.5828 13.5766 11.1647 13.6924C11.7467 13.8081 12.3499 13.7487 12.8981 13.5216C13.4462 13.2946 13.9148 12.9101 14.2444 12.4167C14.5741 11.9234 14.75 11.3433 14.75 10.75C14.7492 9.95461 14.4328 9.19202 13.8704 8.62959C13.308 8.06716 12.5454 7.75083 11.75 7.75ZM11.75 12.25C11.4533 12.25 11.1633 12.162 10.9166 11.9972C10.67 11.8324 10.4777 11.5981 10.3642 11.324C10.2507 11.0499 10.2209 10.7483 10.2788 10.4574C10.3367 10.1664 10.4796 9.89912 10.6893 9.68934C10.8991 9.47956 11.1664 9.3367 11.4574 9.27882C11.7483 9.22095 12.0499 9.25065 12.324 9.36418C12.5981 9.47771 12.8324 9.66997 12.9972 9.91665C13.162 10.1633 13.25 10.4533 13.25 10.75C13.25 11.1478 13.092 11.5294 12.8107 11.8107C12.5294 12.092 12.1478 12.25 11.75 12.25ZM4.25 7.75C3.65666 7.75 3.07664 7.92595 2.58329 8.25559C2.08994 8.58524 1.70543 9.05377 1.47836 9.60195C1.2513 10.1501 1.19189 10.7533 1.30765 11.3353C1.4234 11.9172 1.70912 12.4518 2.12868 12.8713C2.54824 13.2909 3.08279 13.5766 3.66473 13.6924C4.24667 13.8081 4.84987 13.7487 5.39805 13.5216C5.94623 13.2946 6.41477 12.9101 6.74441 12.4167C7.07405 11.9234 7.25 11.3433 7.25 10.75C7.24917 9.95461 6.93284 9.19202 6.37041 8.62959C5.80798 8.06716 5.0454 7.75083 4.25 7.75ZM4.25 12.25C3.95333 12.25 3.66332 12.162 3.41665 11.9972C3.16997 11.8324 2.97771 11.5981 2.86418 11.324C2.75065 11.0499 2.72095 10.7483 2.77882 10.4574C2.8367 10.1664 2.97956 9.89912 3.18934 9.68934C3.39912 9.47956 3.66639 9.3367 3.95737 9.27882C4.24834 9.22095 4.54994 9.25065 4.82403 9.36418C5.09812 9.47771 5.33238 9.66997 5.49721 9.91665C5.66203 10.1633 5.75 10.4533 5.75 10.75C5.75 11.1478 5.59197 11.5294 5.31066 11.8107C5.02936 12.092 4.64783 12.25 4.25 12.25Z"
      fill="#455468"
    />
  </svg>
);

export const DocumentIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
    <path d="M384 512L96 512c-53 0-96-43-96-96L0 96C0 43 43 0 96 0L400 0c26.5 0 48 21.5 48 48l0 288c0 20.9-13.4 38.7-32 45.3l0 66.7c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0zM96 384c-17.7 0-32 14.3-32 32s14.3 32 32 32l256 0 0-64-256 0zm32-232c0 13.3 10.7 24 24 24l176 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-176 0c-13.3 0-24 10.7-24 24zm24 72c-13.3 0-24 10.7-24 24s10.7 24 24 24l176 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-176 0z" />
  </svg>
);
